module.exports = __webpack_public_path__ + "static/media/hackeru-logo.80029ae1.png";